import { useGetEmployeeCommissionReport } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function EmployeeCommissionReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:commission')}
      usePivotQuery={useGetEmployeeCommissionReport}
      completeName={['customer']}
    />
  );
}
